import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { useOutletContext } from 'react-router-dom';

const LeftTable = ({ leftTableData, setSelectedItemsInLeft, leftTableRowSelection, setLeftTableRowSelection, rightTableData }) => {
    const tableInstanceRef = useRef(null);
    const {refClientAccountCmsData}=useOutletContext();

    const fetchClientAccountCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccountDetails.SetupClientAccount"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccountDetails.SetupClientAccount"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonComponentCMSLabel = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
            const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
            return returnLabel(commonComponentLabel?.Labels, key)
        }
        return '';
    }
    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: "clientCode",
                header: fetchClientAccountCmsData('ClientAccountDetails.ClientCodes'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientAccountCmsData("ClientAccountDetails.PlaceholderClientCodes") }
            },
            {
                accessorKey: "clientCodeName",
                header: fetchClientAccountCmsData('ClientAccountDetails.ClientCodesNames'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientAccountCmsData("ClientAccountDetails.PlaceholderClientCodesNames") }
            },
        ],
        []
    );

    useEffect(() => {
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        // console.log("tl-selected:", selectedRowObjList)
        setSelectedItemsInLeft(selectedRowObjList)
    }, [leftTableRowSelection])

    const [idsTranferedToRight, setIdsTranferedToRight] = useState([])
    useEffect(() => {
        if (!!rightTableData.length) {
            const list = rightTableData.map((item) => {
                return `${item.clientCode}---${item.clientCodeName}`
            })
            setIdsTranferedToRight(list)
        }
    }, [rightTableData])

    return (
        <Fragment>
            <MaterialReactTable
                tableInstanceRef={tableInstanceRef}
                columns={columns}
                data={leftTableData}
                layoutMode="grid"
                enableGlobalFilter={false}
                enableDensityToggle={false}
                initialState={{
                    density: 'compact',
                    showColumnFilters: true
                }}
                enableRowSelection={(row) => {
                    // console.log("roe", row.original)
                    return !idsTranferedToRight.includes(`${row.original.clientCode}---${row.original.clientCodeName}`)
                }}
                muiTablePaginationProps={{
                    labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
                }}
                getRowId={(originalRow) => `${originalRow.clientCode}---${originalRow.clientCodeName}`} //give each row a more useful id
                onRowSelectionChange={setLeftTableRowSelection} //connect internal row selection state to your own
                state={{ rowSelection: leftTableRowSelection }}
                enableStickyHeader
                muiTableContainerProps={{
                    sx: {
                        height: { sx: 200, sm: 300, md: 500 },
                    }
                }}
            />
        </Fragment>

    );
};

export default LeftTable;
